import Link from "next/link";
import Image from "next/image";
import React, { useEffect, useMemo, useState } from "react";
import { inject, observer } from "mobx-react";
import { BLOOD_GROUPS } from "../../../entities";
import { Props } from "./IProps";
import Button from "../ui/button/Button";
import MyButton from "../../myButton";
import redirectTo from "../../../utils/redirectTo";

import { Variables } from "./hooks/Variables";
import { useMiddleNameVariables } from "./hooks/useMiddleNameVariables";
import { useLastNameVariables } from "./hooks/useLastNameVariables";
import { useFirstNameVariables } from "./hooks/useFirstNameVariables";
import { useBloodGroupVariables } from "./hooks/useBloodGroupVariables";
import { useEmailVariables } from "./hooks/useEmailVariables";
import { usePhoneVariables } from "./hooks/usePhoneVariables";
import { useCountDonationsVariables } from "./hooks/useCountDonations";
import { useEmailReconfirmationVariables } from "./hooks/useEmailReconfirmationVariables";
import { usePhoneReconfirmationVariables } from "./hooks/usePhoneReconfirmationVariables";
import { useRejectedDonationVariables } from "./hooks/useRejectedDonationVariables";
import { useDownloadCertificateVariables } from "./hooks/useDownloadCertificateVariables";
import { useSubscribeTelegramVariables } from "./hooks/useSubscribeTelegramVariables";
import { useSubscribeVkontakteVariables } from "./hooks/useSubscribeVkontakteVariables";
import { useEmailUnavaibleVariables } from "./hooks/useEmailUnavaibleVariables";
import DonateTrigger from "./finalTriggers/DonateTrigger";
import ImpactTrigger from "./finalTriggers/ImpactTrigger";

import styles from "./trigger.module.scss";

const Trigger: React.FC<Props> = (props) => {
  const {
    triggerStore,
    authStore,
    donorCardStore,
    triggerInfo,
    setTriggerInfo,
    donationsBeforeRegStore,
  } = props;
  const [loader, setLoader] = useState(true);
  const [value, setValue] = useState({ value: "", label: "" });
  const bloodoptions = Object.keys(BLOOD_GROUPS).map((key) => {
    return { value: key, label: BLOOD_GROUPS[key] };
  });
  const [statusCard, setStatusCard] = useState(1);
  const [count, setCount] = useState(60);
  const [confirmCode, setConfirmCode] = useState("");
  const [intervalId, setIntervalId] = useState(null);
  const [errors, setErrors] = useState("");

  const MiddleNameVariables = useMiddleNameVariables(errors, value, setValue)
  const LastNameVariables = useLastNameVariables(errors, value, setValue)
  const FirstNameVariables = useFirstNameVariables(errors, value, setValue)
  const BloodGroupVariables = useBloodGroupVariables(bloodoptions, value, setValue)
  const EmailVariables = useEmailVariables(errors, count, value, setValue, confirmCode, setConfirmCode)
  const PhoneVariables = usePhoneVariables(errors, count, value, setValue, confirmCode, setConfirmCode)
  const CountDonationsVariables = useCountDonationsVariables(errors, value, setValue)
  const EmailReconfirmationVariables = useEmailReconfirmationVariables(authStore?.user?.email)
  const PhoneReconfirmationVariables = usePhoneReconfirmationVariables(authStore?.user?.phone)
  const RejectedDonationDonationVariables = useRejectedDonationVariables(triggerInfo?.context?.reject_reason)
  const DownloadCertificateVariables = useDownloadCertificateVariables(triggerInfo.context?.donations_before_reg, triggerInfo.context?.accepted_donations)
  const SubscribeTelegramVariables = useSubscribeTelegramVariables()
  const SubscribeVkontakteVariables = useSubscribeVkontakteVariables()
  const EmailUnavaibleVariables = useEmailUnavaibleVariables(authStore.user?.email)

  const allFilled = new Variables();

  const maxPromptTypes = ["upload_missing_donations", "rejected_donation"]
  const infoTriggerTypes = ["subscribe_to_us_telegram", "subscribe_to_us_vkontakte"]
  const labelSmallTypes = ["upload_missing_donations", "subscribe_to_us_telegram", "subscribe_to_us_vkontakte"]

  const getTriggerInfo = () => {
    triggerStore
      .loadTrigger()
      .then((data) => {
        // const res = {
        //   type: "subscribe_to_us_telegram",
        //   context: {}
        // }
        setTriggerInfo(data);
        setStatusCard(1);
        setValue({ value: "", label: "" });
        setErrors("");
        setConfirmCode("");
        setCount(60);
        setLoader(false);
      })
      .catch((err) => console.log(err));
  };

  // Phone
  const resendPhone = () => {
    authStore
      .change_phone(`+${value.value}`)
      .then((res) => {
        setErrors("");
        setStatusCard(2);
      })
      .catch((err) => {
        if (err.response.data?.phone) {
          setErrors(err.response.data?.phone[0])
        }
        if (err.response.data?.seconds) {
          setCount(Number(err.response.data.seconds[0]))
          setErrors("");
          setStatusCard(2);
        }
      });
  };

  const handleConfirmCodePhone = () => {
    authStore
      .confirm_phone(`+${value.value}`, confirmCode)
      .then((res) => setStatusCard(3))
      .catch((err) => setErrors(err.response.data?.code[0]));
  };

  // Email
  const resendEmail = () => {
    authStore
      .change_email(value.value)
      .then((res) => {
        setErrors("");
        setStatusCard(2);
      })
      .catch((err) => setErrors(err.response.data?.email[0]));
  };

  const handleConfirmCodeEmail = () => {
    authStore
      .confirm_email(value.value, confirmCode)
      .then((res) => setStatusCard(3))
      .catch((err) => setErrors(err.response.data?.code[0]));
  };

  const handleUpdateUserData = () => {
    authStore
      .update({ [triggerInfo.type]: value.value })
      .then((res) => setStatusCard(2))
      .catch((err) => setErrors(err.response.data?.[triggerInfo.type][0]));
  };

  const handleUpdateBloodGroup = () => {
    donorCardStore
      .update({ [triggerInfo.type]: value.value })
      .then((data) => {
        setStatusCard(2);
        // Делаю запрос данных пользователя, если изменилась группа крови
        authStore.fetchCurrentUser();
      })
      .catch((err) => setErrors(err.response.data?.[triggerInfo.type][0]));
  };

  const handleReturnStatusStart = () => {
    if (children.typeImg === "close") {
      setStatusCard(1);
      setValue({ value: "", label: "" });
      setErrors("");
      setConfirmCode("");
      setCount(60);
    }
  };

  // Отправка кол-ва донаций пользователя
  const handleSendDonations = () => {
    donationsBeforeRegStore
      .sendCountDonations({
        donations_before_reg: value.label,
      })
      .then(() => setStatusCard(2))
      .catch((err) => setErrors(err.response.data?.donations_before_reg[0]));
  };

  // Подтверждение email или телефона, если он не изменился через год.
  const reConfirm = () => {
    const currentDate = new Date();
    const moscowTime = new Date(
      currentDate.toLocaleString("en-US", { timeZone: "Europe/Moscow" })
    );
    const year = moscowTime.getFullYear();
    const month = String(moscowTime.getMonth() + 1).padStart(2, "0");
    const day = String(moscowTime.getDate()).padStart(2, "0");
    const hours = String(moscowTime.getHours()).padStart(2, "0");
    const minutes = String(moscowTime.getMinutes()).padStart(2, "0");
    const date = `${year}-${month}-${day} ${hours}:${minutes}`;
    let key;
    if (triggerInfo.type === "email_reconfirmation" || triggerInfo.type === "cardsmobile_email_reconfirmation") {
      key = "email_reconfirmed_at" as const;
    } else if (triggerInfo.type === "phone_reconfirmation" || triggerInfo.type === "cardsmobile_phone_reconfirmation") {
      key = "phone_reconfirmed_at" as const;
    }
    if (key) {
      authStore
        .update({ [key]: date })
        .then(() => setStatusCard(2))
        .catch((err) => console.log(err));
    }
  };

  const hideInfoTrigger = () => {
    const currentDate = new Date();
    const moscowTime = new Date(
      currentDate.toLocaleString("en-US", { timeZone: "Europe/Moscow" })
    );
    const year = moscowTime.getFullYear();
    const month = String(moscowTime.getMonth() + 1).padStart(2, "0");
    const day = String(moscowTime.getDate()).padStart(2, "0");
    const date = `${year}-${month}-${day}`;
    let key;

    if (triggerInfo.type === "subscribe_to_us_telegram") {
      key = "telegram_trigger_hidden_at" as const;
    }

    if (triggerInfo.type === "subscribe_to_us_vkontakte") {
      key = "vkontakte_trigger_hidden_at" as const;
    }

    if (triggerInfo.type === "email_unavailable_for_mailing") {
      key = "email_unavailable_trigger_hidden_at" as const;
    }

    if (key) {
      authStore
        .updateMetadata({ [key]: date })
        .then(() => setStatusCard(2))
        .catch((err) => console.log(err));
    }
  }

  const onSubmith = () => {
    if (statusCard === 1) {
      if (triggerInfo.type === "email_reconfirmation") {
        setTriggerInfo({ type: "email" });
      }
      if (triggerInfo.type === "apple_proxy_email") {
        setTriggerInfo({ type: "email" });
        resendEmail();
      }
      if (triggerInfo.type === "cardsmobile_email_reconfirmation") {
        setTriggerInfo({ type: "email" });
      }
      if (triggerInfo.type === "phone_reconfirmation") {
        setTriggerInfo({ type: "phone" });
      }
      if (triggerInfo.type === "cardsmobile_phone_reconfirmation") {
        setTriggerInfo({ type: "phone" });
      }
      if (triggerInfo.type === "phone") {
        resendPhone();
      }
      if (triggerInfo.type === "email") {
        resendEmail();
      }
      if (
        triggerInfo.type === "first_name" ||
        triggerInfo.type === "last_name" ||
        triggerInfo.type === "middle_name"
      ) {
        handleUpdateUserData();
      }
      if (triggerInfo.type === "blood_group") {
        handleUpdateBloodGroup();
      }
      if (triggerInfo.type === "donations_before_reg") {
        handleSendDonations();
      }
      if (triggerInfo.type === "rejected_donation") {
        redirectTo(`/profile/donations/${triggerInfo?.context?.donation_id}`)
      }
      if (triggerInfo.type === "upload_missing_donations") {
        redirectTo(`/profile/add_donation`)
      }
      if (triggerInfo.type === "subscribe_to_us_telegram") {
        window.open("https://t.me/donorsearch", '_blank');
      }
      if (triggerInfo.type === "subscribe_to_us_vkontakte") {
        window.open("https://vk.com/donorsearch", '_blank');
      }
      if (triggerInfo.type === "email_unavailable_for_mailing") {
        window.open("https://sendsay.ru/form/donorsearch/10/", '_blank');
      }
    } else if (statusCard === 2) {
      if (triggerInfo.type === "phone") {
        handleConfirmCodePhone();
      } else if (triggerInfo.type === "email") {
        handleConfirmCodeEmail();
      }
    }
  };

  const requestCodeResend = () => {
    if (count === 0) {
      if (triggerInfo.type === "phone") {
        resendPhone();
      }
      if (triggerInfo.type === "email") {
        resendEmail();
      }
      setCount(60);
    }
  };

  const handleChangeCount = () => {
    if (statusCard === 2) {
      const id = setInterval(() => {
        setCount((prev) => (prev >= 1 ? prev - 1 : 0));
      }, 1000);
      setIntervalId(id);
    } else {
      clearInterval(intervalId);
    }
  };

  useEffect(() => {
    handleChangeCount();
    if (statusCard === 3) {
      setTimeout(() => {
        getTriggerInfo();
      }, 3000);
    }
    if (
      statusCard === 2 &&
      (triggerInfo.type === "first_name" ||
        triggerInfo.type === "last_name" ||
        triggerInfo.type === "middle_name" ||
        triggerInfo.type === "blood_group" ||
        triggerInfo.type === "donations_before_reg" ||
        triggerInfo.type === "email_reconfirmation" ||
        triggerInfo.type === "phone_reconfirmation" ||
        // triggerInfo.type === "apple_proxy_email" ||
        triggerInfo.type === "cardsmobile_phone_reconfirmation" ||
        triggerInfo.type === "cardsmobile_email_reconfirmation" ||
        triggerInfo.type === "subscribe_to_us_telegram" ||
        triggerInfo.type === "subscribe_to_us_vkontakte" ||
        triggerInfo.type === "email_unavailable_for_mailing"
      )
    ) {
      setTimeout(() => {
        getTriggerInfo();
      }, (infoTriggerTypes.includes(triggerInfo.type) || triggerInfo.type === "email_unavailable_for_mailing") ? 0 : 3000);
    }
  }, [statusCard]);

  useEffect(() => {
    getTriggerInfo();
  }, []);

  const fields = {
    first_name: {
      elementary: FirstNameVariables.elementary,
      success: FirstNameVariables.success,
    },
    last_name: {
      elementary: LastNameVariables.elementary,
      success: LastNameVariables.success,
    },
    middle_name: {
      elementary: MiddleNameVariables.elementary,
      success: MiddleNameVariables.success,
    },
    blood_group: {
      elementary: BloodGroupVariables.elementary,
      success: BloodGroupVariables.success,
    },
    email: {
      elementary: EmailVariables.elementary,
      confirmation: EmailVariables?.confirmation,
      success: EmailVariables.success,
    },
    apple_proxy_email: {
      elementary: EmailVariables.elementary,
      confirmation: EmailVariables?.confirmation,
      success: EmailVariables.success,
    },
    phone: {
      elementary: PhoneVariables.elementary,
      confirmation: PhoneVariables?.confirmation,
      success: PhoneVariables.success,
    },
    donations_before_reg: {
      elementary: CountDonationsVariables.elementary,
      success: CountDonationsVariables.success,
    },
    email_reconfirmation: {
      elementary: EmailReconfirmationVariables.elementary,
      confirmation: EmailReconfirmationVariables?.confirmation,
      success: EmailReconfirmationVariables.success,
    },
    cardsmobile_email_reconfirmation: {
      elementary: EmailReconfirmationVariables.elementary,
      confirmation: EmailReconfirmationVariables?.confirmation,
      success: EmailReconfirmationVariables.success,
    },
    phone_reconfirmation: {
      elementary: PhoneReconfirmationVariables.elementary,
      confirmation: PhoneReconfirmationVariables?.confirmation,
      success: PhoneReconfirmationVariables.success,
    },
    cardsmobile_phone_reconfirmation: {
      elementary: PhoneReconfirmationVariables.elementary,
      confirmation: PhoneReconfirmationVariables?.confirmation,
      success: PhoneReconfirmationVariables.success,
    },
    rejected_donation: {
      elementary: RejectedDonationDonationVariables.elementary,
    },
    upload_missing_donations: {
      elementary: DownloadCertificateVariables.elementary,
    },
    subscribe_to_us_telegram: {
      elementary: SubscribeTelegramVariables.elementary,
    },
    subscribe_to_us_vkontakte: {
      elementary: SubscribeVkontakteVariables.elementary,
    },
    email_unavailable_for_mailing: {
      elementary: EmailUnavaibleVariables.elementary,
    }
  };

  function getField() {
    const { type } = triggerInfo;
    const field = fields[type];
    if (!field) {
      return allFilled.elementary;
    }
    const { elementary, confirmation, success } = field;
    if (statusCard === 1) {
      return elementary;
    }
    if (statusCard === 2) {
      return confirmation ?? success;
    }
    return success;
  }

  const renderRandomFinallTrigger = useMemo(() => {
    const finalTriggers = [<DonateTrigger />];

    if (authStore?.user?.donation_agg?.count >= 10) {
      finalTriggers.push(<ImpactTrigger />);
    }

    const randomIndex = Math.floor(Math.random() * finalTriggers.length);

    return finalTriggers[randomIndex];
  }, [authStore?.user?.donation_agg?.count])

  const children = getField();

  return (
    <div className={styles.Trigger}>
      {triggerInfo.type !== "all_filled" ? (
        <div
          className={
            !loader
              ? `${styles.Content} ${children?.succesImg && styles.ContentSucces
              } ${infoTriggerTypes.includes(triggerInfo.type) ? styles.BlueBorder : ""}`
              : styles.Show
          }
        >
          <div className={styles.TriggerHead}>
            <h5 className={styles.TriggerHead__title}>
              {children?.title}
              <span>{children?.bold}</span>
              {children?.afterTitle}
            </h5>
            {children?.img && (
              <div className={styles.TriggerHeadPrompt}>
                <Image
                  className={styles.TriggerHeadPromptImg}
                  onClick={handleReturnStatusStart}
                  src={children?.img}
                  width={21}
                  height={21}
                  alt="icon"
                />
                {children?.prompt && (
                  <div className={`${!maxPromptTypes.includes(triggerInfo.type) ? styles.TriggerHeadPromptPopup : styles.TriggerHeadPromptPopupMax}`}>
                    <span className={styles.TriggerHeadPromptPopupContent}>
                      {children?.prompt}
                    </span>
                    <ul style={{ margin: "5px 0 0", padding: "0 0 0 15px" }}>
                      {children?.promptList?.map((item, index) => (
                        <li
                          key={index}
                          dangerouslySetInnerHTML={{ __html: item }}
                        ></li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
          </div>
          {children?.centralText && (
            <p
              className={styles.TriggerCentralText}
              title={children?.centralText}
            >
              {children?.centralText}
            </p>
          )}
          <div className={styles.TriggerHtmlElement}>
            {children?.errorCode}
            <label className={`${!labelSmallTypes.includes(triggerInfo.type) ? styles.TriggerHtmlElement__label : styles.TriggerHtmlElement__labelSmall}`}>
              {children?.label}
              <span className={styles.TriggerHtmlElement__labelBold}>
                {children?.labelBold}
              </span>
            </label>
            {children?.htmlElement}
            {children?.errorMessage && (
              <span className={styles.TriggerHtmlElement__error}>
                {children?.errorMessage}
              </span>
            )}
          </div>
          {children?.counter && (
            <button
              className={styles.Content__counter}
              onClick={requestCodeResend}
            >
              {children?.counter}
            </button>
          )}
          {children?.button && (
            <div className={`${styles.Content__btns} ${triggerInfo.type === "email_unavailable_for_mailing" ? styles.Content__btnsVertical : ""}`}>
              <Button
                children={children?.button}
                color={`${children?.typeButton === "confirm" ? "green" : ""}`}
                onClick={onSubmith}
              />
              {children?.confirmBtn && (
                <Button
                  children={children?.confirmBtn}
                  color={"black"}
                  onClick={reConfirm}
                />
              )}
              {children?.buttonHide && (
                <span className={styles.HideButton} onClick={hideInfoTrigger}>{children?.buttonHide}</span>
              )}
            </div>
          )}
          {children?.buttonInfo && (
            <div className={styles.Content__btns}>
              <button
                children={children?.buttonInfo}
                className={styles.ButtonInfo}
                onClick={() => onSubmith()}
              />
              {children?.buttonHide && (
                <span className={styles.HideButton} onClick={hideInfoTrigger}>{children?.buttonHide}</span>
              )}
            </div>
          )}
          {children?.succesImg && (
            <div
              className={`${styles.Trigger__success} ${styles.TriggerBottom}`}
            >
              <Image
                className={styles.TriggerBottom__img}
                src={children?.succesImg}
                alt="succes"
                width={20}
                height={20}
              />
              <span className={styles.TriggerBottom__text}>
                {children?.message}
              </span>
            </div>
          )}
        </div>
      ) : (
        renderRandomFinallTrigger
      )}
    </div>
  );
};

export default inject(
  "triggerStore",
  "authStore",
  "donorCardStore",
  "donationsBeforeRegStore"
)(observer(Trigger));
